angular
  .module("pe4h")
  .controller("ViewEngineers", function(
    $scope,
    $http,
    $state,
    angularGridInstance
  ) {

    function capitalize(text) {
      if(text){
        return text.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
      }
      return ""
    }

    $scope.onScroll = function(scrollTop) {
      angularGridInstance.gallery.handleScroll(scrollTop);
    };

    $scope.generateSEODescriptionForEng = function(engineer){
      var seoTitle = "freelance engineer";
      if(engineer.City){
        seoTitle += " in "+ engineer.City;
        if(engineer.State){
          seoTitle += ",-"+engineer.State;
        }
      }
      return seoTitle.toLowerCase().replace(/ /g, "-");
    };

    // Get engineers filtered by state and license
    $scope.loadEngineers = function(pageSize, currentPage) {
      $scope.loadingEngineers = true;
      $http({
        url: configuration.webApi.users.engineers({
          state: $scope.filters.state && $scope.filters.state.Code ? "'" + $scope.filters.state.Code + "'" : "",
          licenseId: $scope.filters.license && $scope.filters.license.Id ? $scope.filters.license.Id : "",
          pageSize:  pageSize,
          currentPage: currentPage
        }),
        method: "GET"
      })
        .success(function(res, status, headers, config) {
          var isStateFilter = $scope.filters.state && $scope.filters.state.Code;
          var isLicenseFilter = $scope.filters.license && $scope.filters.license.Id;
          
          if(isStateFilter || isLicenseFilter) {
            var newStateFilter = (isStateFilter && $scope.filters.state.Code) != $scope.engineersFiltered.stateCode;
            if(newStateFilter){
              $scope.engineersFiltered.stateCode = $scope.filters.state.Code;
            }
            
            var newLicenseFilter = (isLicenseFilter && $scope.filters.license.Id) != $scope.engineersFiltered.licenseId;
            if(newLicenseFilter){
              $scope.engineersFiltered.licenseId = $scope.filters.license.Id;
            }
            
            $scope.engineersAll = newStateFilter || newLicenseFilter ? res : $scope.engineersAll.concat(res);
            $scope.engineers = newStateFilter || newLicenseFilter ? res : $scope.engineers.concat(res);
            
            $scope.engineersFiltered.status = true;
          }else{
            $scope.engineersAll = !$scope.engineersFiltered.status ? $scope.engineersAll.concat(res) : res;
            $scope.engineers = !$scope.engineersFiltered.status ? $scope.engineers.concat(res) : res;
            $scope.engineersFiltered.status = false;
            $scope.engineersFiltered.stateCode = null;
            $scope.engineersFiltered.licenseId = null;
          }
          $scope.paging.total = $scope.engineers.length;
          $scope.groupLicenses();
          $scope.loadingEngineers = false;
          $scope.loading = false;
        })
        .error(function(error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          $scope.loadingEngineers = false;
        });
    };

    //to display them grouped on profile
    $scope.groupLicenses = function() {
      $scope.engineersAll.forEach(function(item) {
        item.groupedLicenses = _.groupBy(item.licenses, function(item) {
          return item.LicenseId;
        });
      });
    };

    $scope.findLicenseParagraph1 = function(licenseId){
      if($scope.licensesInformation){
        var p = _.find($scope.licensesInformation, function(item){return item.LicenseId == licenseId})
        if (p) return p.Paragraph1;
        var def = _.find($scope.licensesInformation, function(item){return item.LicenseId == 0});
        return def.Paragraph1;
      }
      return "";
    }
    $scope.findLicenseParagraph2 = function(licenseId){
      if($scope.licensesInformation){
        var p = _.find($scope.licensesInformation, function(item){return item.LicenseId == licenseId})
        if (p) return p.Paragraph2;
        var def = _.find($scope.licensesInformation, function(item){return item.LicenseId == 0});
        return def.Paragraph2;
      }
      return "";
    }

    $scope.getMoreEngineers = function() {
      if (!$scope.loading) {
          $scope.loading = true;
          $scope.paging.current += 1;

          $scope.loadEngineers($scope.itemsPerPage, $scope.paging.current);
      }
    };

    $scope.onLicenseChange = function() {
      $scope.paging.current = 1;
      $scope.loadEngineers($scope.itemsPerPage, $scope.paging.current);
      $scope.updateTitle();
    };

    $scope.onStateChange = function() {
      $scope.paging.current = 1;
      $scope.loadEngineers($scope.itemsPerPage, $scope.paging.current);
      $scope.updateTitle();
    };

    function findInArray(array, key, element){
      for(var index in array){
        if(array[index][key].toLowerCase() == element.toLowerCase()){
          return array[index];
          break;
        }
      }
    }

    $scope.updateTitle = function(){
        var currentState = $scope.filters.state.Label;
        var currentStateId = $scope.filters.state.Code;
        var currentLicense = $scope.filters.license.Label;
        var currentLicenseId = $scope.filters.license.Id;

        if((!currentState || currentStateId === null) && (!currentLicense || currentLicenseId === null)){
          $scope.engineersTitle = "Engineers";
          $scope.pageTitle = "Engineers | PEforHire.com";
          $scope.pageDescription = "Need an Engineer? Find licensed Engineers near me and get FREE proposals for your project on PEforHire.com";
        }
        if((currentState && currentStateId !== null) && (!currentLicense || currentLicenseId === null)){
          $scope.engineersTitle = "Engineers in "+ currentState;
          $scope.pageTitle = "Engineers in "+ currentState +" | PEforHire.com";
          $scope.pageDescription = "Need an Engineer in "+ currentState +"? Find licensed Engineers near me and get FREE proposals for your project on PEforHire.com";
        }
        if((!currentState || currentStateId === null) && currentLicense && currentLicenseId !== null){
          $scope.engineersTitle = currentLicense+"s";
          $scope.pageTitle = currentLicense + "s | PEforHire.com";
          $scope.pageDescription = "Need a "+ currentLicense +"? Find licensed "+ currentLicense +"s near me and get FREE proposals for your project on PEforHire.com";
        }
        if((currentState && currentStateId !== null) && (currentLicense && currentLicenseId !== null)){
          $scope.engineersTitle = currentLicense + "s in " + currentState;
          $scope.pageTitle = currentLicense + "s in " + currentState + " | PEforHire.com";
          $scope.pageDescription = "Need a "+ currentLicense +"? Find licensed "+ currentLicense +"s near me and get FREE proposals for your project on PEforHire.com";
        }
    };

    function init() {
      // Default values
      $scope.assetsUrl = configuration.assetsUrl;
      $scope.engineersTitle = "Engineers";

      var allLicenses = {
        Id: null,
        Label: "Licenses (All)",
        Available: true
      };

      var allStates = {
        Code: null,
        Label: "States (All)",
        Available: true
      };

      $scope.engineerLicenses = angular.copy($scope.licenses);
      $scope.engineerLicenses.unshift(allLicenses);
      $scope.engineerStates = angular.copy($scope.states);
      $scope.engineerStates.unshift(allStates);

      $scope.filters = {
        state: null, //$scope.engineerStates[0].Code,
        license: null //$scope.engineerLicenses[0].Id
      };
      $scope.pageTitle = "Engineers | PEforHire.com";
      $scope.pageDescription = "Need an Engineer? Find licensed Engineers near me and get FREE proposals for your project on PEforHire.com";

      // Get description from the url
      var param1 = $state.params.param1.replace(/-/g, " ");
      var param2 = $state.params.param2.replace(/-/g, " ");
      var selectedLicense = {};
      var selectedState = {};

      // If param1 is 'engineer', do nothing
      if(param1 != "engineer"){
        var param1License = findInArray($scope.engineerLicenses, "Label", param1);
        if (param1License) selectedLicense = param1License;

        // If param2 is present, then param1 = license & param2 = state
        if(param2){
          var param2State = findInArray($scope.engineerStates, "Label", param2);
          if (param2State) selectedState = param2State;
        }else{
          // When we only have param1, we need to know if param1 is a state or license
          var param1State = findInArray($scope.engineerStates, "Label", param1);
          if (param1State) selectedState = param1State;
        }
      }

      $scope.filters.state = selectedState;
      $scope.filters.license = selectedLicense;
      $scope.updateTitle();

      $scope.loading = true;
      $scope.engineers = [];
      $scope.engineersAll = [];
      $scope.engineersFiltered = {
        status: false,
        stateCode: null,
        licenseId: null
      }

      // Paging
      $scope.itemsPerPage = 12;
      $scope.paging = {
        current: 1
      };
      $scope.loadingEngineers = false;
      $scope.loadEngineers($scope.itemsPerPage, $scope.paging.current);
    }

    init();
  });
